import { render, staticRenderFns } from "./QualityTvRow.vue?vue&type=template&id=3154fd73&scoped=true"
import script from "./QualityTvRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualityTvRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QualityTvRow.vue?vue&type=style&index=0&id=3154fd73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154fd73",
  null
  
)

export default component.exports